// Track the `INPAGE_JS_FINISHED_EXECUTING` lifecycle (after the JS has been downloaded and parsed
// and is just starting to run). Need to use `Date.now` instead of `performance.now` because the
// iframe's `performance.timing.navigationStart` will not match the parent's `navigationStart`

window.hsQueuedLifecycleTimestamps = window.hsQueuedLifecycleTimestamps || {};
window.hsQueuedLifecycleTimestamps.INPAGE_JS_FINISHED_EXECUTING = Date.now();

if (window.performance.mark) {
  window.performance.mark('INPAGE_JS_FINISHED_EXECUTING');
}


"use strict";
'use es6';

(function () {
  for (let i = 0; i < window.__hsRoot.globals.length; i++) {
    window.__hsRoot.restoreGlobal(window.__hsRoot.globals[i]);
  }
})();





